import * as actions from '~/library/actions';

const defaultState = {
  component: {},
  componentId: null,
  commitHash: '',
  commitHashTab: null,
  cvss: 'cvss2',
  isLoadingComponent: false,
  isLoadingVulnerabilities: false,
  isLoadingVersionVulnerabilities: false,
  isLoadingCommitHashVulnerabilities: false,
  isLoadingVulnerableVersions: false,
  isLoadingLicenses: false,
  licenses: null,
  tab: 'summary',
  url: '',
  title: '',
  language: '',
  onlyVulnerableVersions: false,
  packageManager: '',
  version: null,
  versionTab: null,
  vulnerabilities: [],
  vulnerabilityFilter: '',
  versionFilter: '',
  versionVulnerabilityFilter: '',
  commitHashVulnerabilityFilter: '',
  vulnerabilitiesByVersion: {},
  vulnerabilitiesByCommitHash: {},
  vulnerableVersions: [],
  versionVulnerabilityErrors: {},
  commitHashVulnerabilityErrors: {},
  vulnerabilityFetchError: false,
};

const libraryState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.REQUEST_LOAD_COMPONENT:
      return Object.assign({}, state, {
        isLoadingComponent: true,
      });
    case actions.RECEIVE_LOAD_COMPONENT:
      return Object.assign({}, state, {
        isLoadingComponent: false,
        componentId: +action.id,
        component: action.component,
      });
    case actions.UPDATE_TAB:
      return Object.assign({}, state, {
        tab: action.tab,
      });
    case actions.UPDATE_VERSION:
      return Object.assign({}, state, {
        version:
          (action.version.toUpperCase() === 'HEAD' && action.version.toUpperCase()) ||
          action.version,
        licenses: null,
      });
    case actions.UPDATE_VERSION_TAB:
      return Object.assign({}, state, {
        versionTab: action.versionTab,
      });
    case actions.UPDATE_COMMIT_HASH:
      return Object.assign({}, state, {
        commitHash: action.commitHash,
      });
    case actions.UPDATE_COMMIT_HASH_TAB:
      return Object.assign({}, state, {
        commitHashTab: action.commitHashTab,
      });
    case actions.UDPATE_LATEST_COMMIT_HASHES:
      return Object.assign({}, state, {
        latestCommitHashes: action.latestCommitHashes,
      });
    case actions.UDPATE_LIBRARY_CVSS_SELECTION:
      return Object.assign({}, state, {
        cvss: action.cvss,
      });
    case actions.LOAD_URL_AND_PARAMS:
      return Object.assign({}, state, {
        url: action.url,
        title: action.title,
        language: action.language,
        packageManager: action.packageManager,
      });
    case actions.REQUEST_VULNERABILITIES:
      return Object.assign({}, state, {
        isLoadingVulnerabilities: true,
        vulnerabilityFetchError: false,
      });
    case actions.RECEIVE_VULNERABILITIES:
      return Object.assign({}, state, {
        isLoadingVulnerabilities: false,
        vulnerabilities: action.vulnerabilities,
      });
    case actions.UPDATE_VULNERABILITY_FILTER:
      return Object.assign({}, state, {
        vulnerabilityFilter: action.filter,
      });
    case actions.UPDATE_VERSION_VULNERABILITY_FILTER:
      return Object.assign({}, state, {
        versionVulnerabilityFilter: action.filter,
      });
    case actions.UPDATE_COMMITHASH_VULNERABILITY_FILTER:
      return Object.assign({}, state, {
        commitHashVulnerabilityFilter: action.filter,
      });
    case actions.UPDATE_VERSION_FILTER:
      return Object.assign({}, state, {
        versionFilter: action.filter,
      });
    case actions.REQUEST_VERSION_VULNERABILITIES:
      return Object.assign({}, state, {
        isLoadingVersionVulnerabilities: true,
        currentVersionVulnerabilityError: false,
      });
    case actions.REQUEST_COMMITHASH_VULNERABILITIES:
      return Object.assign({}, state, {
        isLoadingCommitHashVulnerabilities: true,
        currentCommitHashVulnerabilityError: false,
      });
    case actions.RECEIVE_VERSION_VULNERABILITIES: {
      const newVulnsByVersion = state.vulnerabilitiesByVersion;
      newVulnsByVersion[action.version] = action.vulnerabilities;

      return Object.assign({}, state, {
        vulnerabilitiesByVersion: newVulnsByVersion,
        isLoadingVersionVulnerabilities: false,
        currentVersionVulnerabilityError: false,
      });
    }
    case actions.RECEIVE_COMMITHASH_VULNERABILITIES: {
      const newVulnsByCommitHash = state.vulnerabilitiesByCommitHash;
      newVulnsByCommitHash[action.commitHash] = action.vulnerabilities;

      return Object.assign({}, state, {
        vulnerabilitiesByCommitHash: newVulnsByCommitHash,
        isLoadingCommitHashVulnerabilities: false,
        currentCommitHashVulnerabilityError: false,
      });
    }
    case actions.REQUEST_LICENSES:
      return Object.assign({}, state, {
        isLoadingLicenses: action.isLoadingLicenses,
      });
    case actions.RECEIVE_LICENSES:
      return Object.assign({}, state, {
        isLoadingLicenses: action.isLoadingLicenses,
        licenses: action.licenses,
      });
    case actions.RESET_COMPONENT:
      return Object.assign({}, state, {
        component: {},
        componentId: null,
        version: null,
        licenses: null,
        vulnerabilities: null,
        vulnerabilitiesByVersion: {},
        vulnerableVersions: [],
        onlyVulnerableVersions: false,
        versionVulnerabilityErrors: {},
        vulnerabilityFetchError: false,
      });
    case actions.REQUEST_VULNERABLE_VERSIONS:
      return Object.assign({}, state, {
        isLoadingVulnerableVersions: true,
      });
    case actions.RECEIVE_VULNERABLE_VERSIONS:
      return Object.assign({}, state, {
        isLoadingVulnerableVersions: false,
        vulnerableVersions: action.vulnerableVersions,
      });
    case actions.TOGGLE_VULNERABLE_VERSIONS:
      return Object.assign({}, state, {
        onlyVulnerableVersions: !state.onlyVulnerableVersions,
      });
    case actions.UPDATE_COMPONENT:
      return Object.assign({}, state, {
        component: action.component,
      });
    case actions.UPDATE_VERSION_VULNERABILITY_ERRORS: {
      const newVulnVersionErrors = state.versionVulnerabilityErrors;
      newVulnVersionErrors[action.version] = action.bool;

      return Object.assign({}, state, {
        versionVulnerabilityErrors: newVulnVersionErrors,
      });
    }
    case actions.UPDATE_COMMITHASH_VULNERABILITY_ERRORS: {
      const newVulnCommitHashErrors = state.commitHashVulnerabilityErrors;
      newVulnCommitHashErrors[action.commitHash] = action.bool;

      return Object.assign({}, state, {
        commitHashVulnerabilityErrors: newVulnCommitHashErrors,
      });
    }
    case actions.UPDATE_VULNERABILITY_FETCH_ERROR:
      return Object.assign({}, state, {
        vulnerabilityFetchError: action.bool,
      });
    default:
      return state;
  }
};

export default libraryState;
